export type RoleId = typeof RoleIds[number];
export const RoleIds = 
[   'employer', 
    'chairperson', 
    'employer_rep',
    'supervisor',
    'work_environment_representative',
    'work_environment_coordinator',
    'work_environment_consultant',
    'staff_representative',
    'human_resource',
    'alternate',
    'employee'
] as const;

export class AmorgRole{

    constructor(
        public id:RoleId,
        public title:string
    ){}
}